import { isValid, secondsToMilliseconds } from 'date-fns';

export const getSafeMilliseconds = (seconds: string | number | undefined) => {
  if (!seconds) return 0;
  if (typeof seconds === 'string' && isValid(new Date(seconds))) return new Date(seconds).getTime();
  if (typeof seconds === 'number') return secondsToMilliseconds(seconds);
  return 0;
};
